import React from 'react';
import { createGlassCard, sharedStyles } from './shared/sharedStyles.js';

/**
 * ProfileDetails - Sidebar showing guest profile information
 *
 * GUEST-SIDE mirror of ShowDetails.jsx. Displays the guest's
 * professional information alongside their show recommendations.
 */
const ProfileDetails = ({ guestProfile }) => {
  return (
    <div style={{
      width: '320px',
      ...createGlassCard(),
      display: 'flex',
      flexDirection: 'column',
      maxHeight: '100%',
      overflow: 'hidden'
    }}>
      {/* Panel Header */}
      <div style={{
        padding: '1rem 1.25rem',
        borderBottom: `1px solid ${sharedStyles.colors.primary}20`,
        background: sharedStyles.colors.surfaceAlt
      }}>
        <h2 style={{
          fontSize: '1.125rem',
          fontWeight: '600',
          color: sharedStyles.colors.textPrimary,
          margin: 0
        }}>
          Your Profile
        </h2>
      </div>

      {/* Profile Info */}
      <div style={{
        padding: '0.75rem 1rem',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        overflow: 'auto'
      }}>
        <div style={{ marginBottom: '0.75rem' }}>
          <h3 style={{
            fontSize: '0.95rem',
            fontWeight: '600',
            color: sharedStyles.colors.textPrimary,
            marginBottom: '0.125rem'
          }}>
            {guestProfile.headline}
          </h3>
          {(guestProfile.title || guestProfile.company) && (
            <p style={{
              color: sharedStyles.colors.textSecondary,
              fontSize: '0.75rem',
              marginBottom: '0.5rem'
            }}>
              {guestProfile.title}{guestProfile.title && guestProfile.company ? ' at ' : ''}{guestProfile.company}
            </p>
          )}
          <p style={{
            color: sharedStyles.colors.textSecondary,
            fontSize: '0.8rem',
            lineHeight: '1.4'
          }}>
            {guestProfile.bio}
          </p>
        </div>

        <div style={{ marginBottom: '0.75rem' }}>
          <h4 style={{
            fontSize: '0.7rem',
            fontWeight: '600',
            color: sharedStyles.colors.textSecondary,
            marginBottom: '0.375rem',
            textTransform: 'uppercase',
            letterSpacing: '0.05em'
          }}>
            Ideal Show Profile
          </h4>
          <p style={{
            color: sharedStyles.colors.textSecondary,
            fontSize: '0.75rem',
            lineHeight: '1.4'
          }}>
            {guestProfile.idealShowProfile}
          </p>
        </div>

        {guestProfile.availability && (
          <div style={{ marginBottom: '0.75rem' }}>
            <h4 style={{
              fontSize: '0.7rem',
              fontWeight: '600',
              color: sharedStyles.colors.textSecondary,
              marginBottom: '0.375rem',
              textTransform: 'uppercase',
              letterSpacing: '0.05em'
            }}>
              Availability
            </h4>
            <p style={{
              color: sharedStyles.colors.textSecondary,
              fontSize: '0.75rem'
            }}>
              {guestProfile.availability}
            </p>
          </div>
        )}

        <div style={{ marginBottom: '0.75rem' }}>
          <h4 style={{
            fontSize: '0.7rem',
            fontWeight: '600',
            color: sharedStyles.colors.textSecondary,
            marginBottom: '0.375rem',
            textTransform: 'uppercase',
            letterSpacing: '0.05em'
          }}>
            Expertise Areas
          </h4>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.25rem' }}>
            {guestProfile.expertiseAreas.map(area => (
              <span key={area} style={{
                background: 'rgba(234, 88, 12, 0.1)',
                color: sharedStyles.colors.accentBrown,
                padding: '0.125rem 0.5rem',
                borderRadius: '6px',
                fontSize: '0.65rem',
                fontWeight: '500'
              }}>
                {area}
              </span>
            ))}
          </div>
        </div>

        <div style={{ flex: 1 }}>
          <h4 style={{
            fontSize: '0.7rem',
            fontWeight: '600',
            color: sharedStyles.colors.textSecondary,
            marginBottom: '0.375rem',
            textTransform: 'uppercase',
            letterSpacing: '0.05em'
          }}>
            Topics
          </h4>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.25rem' }}>
            {guestProfile.topics.map(topic => (
              <span key={topic} style={{
                background: 'rgba(234, 88, 12, 0.1)',
                color: sharedStyles.colors.accentBrown,
                padding: '0.125rem 0.5rem',
                borderRadius: '6px',
                fontSize: '0.65rem',
                fontWeight: '500'
              }}>
                {topic}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileDetails;
